export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'v2.8.1';
